import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e5dbcce"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e5dbcce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationProgramsList: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/ProgramsList.vue').default})
